<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect x="0.5" width="20" height="21" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlink:href="#image0_319_10329"
          transform="matrix(0.0388889 0 0 0.037037 -0.00555556 0)"
        />
      </pattern>
      <image
        id="image0_319_10329"
        width="26"
        height="27"
        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbCAYAAABiFp9rAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANNJREFUeNpiYBiMQEFBwQCI74NoUvUykmIJkNoPxAJA/AGIHR88eHCBWP1MJDgqHmoJA5TeT4rPGEkMuvlAKgFJiGifMZIRT2RZxkhmoiDZMkYKUiBJljFSmNyJtoyRCnmLKMsYqZSRCVrGSMVSA69ljFBFDVSyLx8pU6NYBrPoPw2LSLBlTAx0AixQ+gCVzHPA5ht40NEtMQyJ5E2XDEuXIoguhSpdqgm6VHyUVOVMJFiSQK4lIMBMdIH14cMFAQEBBSDTgJzmFjkJoZ+cBiRAgAEAqkqIgCSLOwEAAAAASUVORK5CYII="
      />
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'AnotherSelectionArrow',
};
</script>
